import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

/**
 * Textarea component with exact Hyperkit styling
 *
 * Hyperkit Specs:
 * - Same shadow system as Input
 * - Border Radius: 6px (rounded-md)
 * - Min Height: 80px (3 lines)
 * - Resize: vertical only
 */
const textareaVariants = cva(
  [
    'flex min-h-20 w-full rounded-md bg-white text-sm text-grey-900',
    'px-3 py-2 transition-shadow duration-150 ease-out',
    'shadow-input resize-y',
    'placeholder:text-grey-400',
    'focus:outline-none focus:shadow-input-focus',
    'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-grey-50 disabled:resize-none',
    // Dark mode
    'dark:bg-grey-900 dark:text-grey-50 dark:placeholder:text-grey-500',
  ],
  {
    variants: {
      error: {
        true: 'shadow-input-error focus:shadow-input-error',
        false: '',
      },
    },
    defaultVariants: {
      error: false,
    },
  }
);

const Textarea = React.forwardRef(({ className, error, ...props }, ref) => {
  return (
    <textarea
      className={cn(textareaVariants({ error }), className)}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea, textareaVariants };
